import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { catchError, EMPTY, tap } from 'rxjs';
import { AcceleratorCatalog } from '../services/accelerator-catalog';
import { AcceleratorCatalogRefresh, AcceleratorCatalogCreate, AcceleratorCatalogUpdate, AcceleratorCatalogDelete, AcceleratorCatalogRefreshByID } from './accelerator-catalog.actions';
import { CatalogService } from '../../catalog-service';
import { Catalog } from 'src/app/common/enumerations/enumerations';
import { AcceleratorCatalogService } from 'src/app/components/home/accelerator-status/accelerator.service';

export class AcceleratorCatalogStateModel {
    data: AcceleratorCatalog[] = [];
}

@State<AcceleratorCatalogStateModel>({
    name: 'AcceleratorCatalogs',
    defaults: {
        data: [],
    },
})
@Injectable()
export class AcceleratorCatalogState extends BaseState {
    constructor(
        protected override injector: Injector,
        private catalogService: CatalogService,
        private service: AcceleratorCatalogService
    ) {
        super(injector);
    }

    @Selector()
    static read(state: AcceleratorCatalogStateModel) {
        return state.data;
    }

    @Action(AcceleratorCatalogRefresh)
    refresh({ patchState }: StateContext<AcceleratorCatalogStateModel>) {
        this.catalogService
            .GetJoinCreated(Catalog.AcceleratorCatalog, true)
            .toPromise()
            .then((data) => {
                patchState({ data: data?.acceleratorCatalogs || [] });
            })
            .catch((error) => {
                console.error(error);
            });
    }

    @Action(AcceleratorCatalogRefreshByID)
    refreshByID(ctx: StateContext<AcceleratorCatalogStateModel>, { id }: AcceleratorCatalogRefreshByID) {
        return this.service.getById(id).pipe(
            tap((acceleratorcatalog) => {
                const state = ctx.getState();
                const index = state.data.findIndex((x) => x.id === id);

                const newData = [...state.data]; // ✅ new array reference

                // (Optional but recommended) ensure acceleratorcatalog is a new object reference too:
                const freshAcceleratorCatalog: AcceleratorCatalog = { ...acceleratorcatalog, details: acceleratorcatalog?.details, pendingDetails: acceleratorcatalog?.pendingDetails, pendingAcceleratorCatalog: acceleratorcatalog?.pendingAcceleratorCatalog };

                if (index >= 0) {
                    if (acceleratorcatalog)
                        newData[index] = freshAcceleratorCatalog; // ✅ replace element immutably
                    else {
                        newData.splice(index, 1); // ✅ remove element immutably
                    }
                } else {
                    newData.push(freshAcceleratorCatalog);
                }

                ctx.patchState({ data: newData });
            }),
            catchError((err) => {
                console.error(err);
                return EMPTY;
            }),
        );
    }

    @Action(AcceleratorCatalogCreate)
    create(
        { getState, patchState }: StateContext<AcceleratorCatalogStateModel>,
        { item }: AcceleratorCatalogCreate,
    ) {
        patchState({
            data: [...getState().data, item],
        });
    }

    @Action(AcceleratorCatalogUpdate)
    update(
        { getState, patchState }: StateContext<AcceleratorCatalogStateModel>,
        { id, item }: AcceleratorCatalogUpdate,
    ) {
        const state = getState();
        const index = state.data.findIndex((x) => x.id === id);
        const currentState = state.data;

        if (index >= 0) {
            currentState.splice(index, 1, item);
            patchState({ data: currentState });
        }
    }

    @Action(AcceleratorCatalogDelete)
    delete(
        { getState, patchState }: StateContext<AcceleratorCatalogStateModel>,
        { id }: AcceleratorCatalogDelete,
    ) {
        patchState({
            data: getState().data.filter((x) => x.id !== id),
        });
    }
}
